<template>
  <footer
    id="footer"
    class="l-footer"
    v-show="
      ![
        '/error',
        '/paintpro/error/error404',
        '/paintpro/error/error500',
        '/paintpro/error/systemCheck',
      ].includes(route.path)
    "
  >
    <!-- D: 로그인페이지를 제외한 footer-top 노출 -->
    <template v-if="!nonPartnerShip">
      <div class="footer-top">
        <div class="footer-top-inner">
          <!-- 2024-12-30 링크추가 -->
          <ul class="partner-list">
            <li>
              <a href="https://www.autorefinishes.co.kr/" target="_blank"
                ><img
                  src="@/assets/images/common/simbol_automotive_refinishes.svg"
                  alt="Automotive Refinishes"
              /></a>
            </li>
            <li>
              <a href="https://www.noroopaint.com/kor/index.asp" target="_blank"
                ><img
                  src="@/assets/images/common/simbol_noroo_paint.svg"
                  alt="노루 페인트"
              /></a>
            </li>
            <li>
              <a href="https://www.soonnsoo.com/" target="_blank"
                ><img
                  src="@/assets/images/common/simbol_soon_soo.svg"
                  alt="soon&soo"
              /></a>
            </li>
            <li>
              <a href="https://www.pantonepaint.co.kr/" target="_blank"
                ><img
                  src="@/assets/images/common/simbol_premium_paints.svg"
                  alt="premium paints"
              /></a>
            </li>
          </ul>
          <!-- // 2024-12-30 링크추가 -->
        </div>
      </div>
    </template>

    <!-- D: 로그인 페이지를 제외한 footer-top 노출 -->
    <div class="footer-btm">
      <div class="footer-btm-inner">
        <div class="footer-left">
          <!-- D: 로그인&회원가입 페이지인 경우  노출 -->
          <template v-if="isJoin">
            <p class="text">
              서비스 이용에 대한 문의사항은 대표전화 031-467-6114 /
              소비자문화센터 080-944-7777(수신자 부담)로 문의하시기 바랍니다.
            </p>
          </template>
          <!-- D: 로그인&회원가입 페이지가 아닌 경우 노출 -->
          <template v-else>
            <p>경기도 안양시 만안구 박달로 351(430-849)</p>
          </template>

          <p class="copy">
            Copyright&copy; 2025 NOROO Paint & Coatings Co.,Ltd. All Rights
            Reserved.
          </p>
        </div>

        <!-- D: 로그인&회원가입 페이지가 아닌 경우 노출 -->
        <template v-if="!isJoin">
          <div class="footer-right">
            <a href="tel:080-944-7777" class="customer-tel"
              >고객문의: 080-944-7777</a
            >
          </div>
        </template>
      </div>

      <!-- 2024-12-16 MO 하단 여백 추가 -->
      <div class="c-spacer" :class="{ 'is-visible': isSpacerVisible }"></div>
    </div>
  </footer>
</template>
<script setup name="footer1">
import { defineProps, onMounted, onBeforeUnmount, ref, nextTick } from "vue";
import { useRoute } from "vue-router";
import * as cmUtil from "@/utils/cmUtil";
const { isMobile } = cmUtil.useDeviceType();
const route = useRoute();
defineProps({
  nonPartnerShip: Boolean,
  isJoin: Boolean,
});

const isSpacerVisible = ref(false);
let observer;

onMounted(() => {
  checkBottomFixed();

  observer = new MutationObserver(() => {
    checkBottomFixed();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});

const checkBottomFixed = () => {
  nextTick(() => {
    const hasBottomFixed =
      document.querySelector("[data-bottom-fixed]") != null;

    if (hasBottomFixed) {
      isSpacerVisible.value = isMobile.value;
    } else {
      isSpacerVisible.value = false;
    }
  });
};
</script>
